import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MeApiService } from '@digilize/shared/data/services';
import { AuthService } from '@digilize/shared/feature/modules/auth/src';
import { SnackbarService } from '@digilize/shared/feature/modules/snackbar/src';
import { getCaptchaHeaders } from '@digilize/shared/utils/helpers/src';
import { ENV_CONFIG } from '@digilize/shared/utils/tokens';
import { EnvConfig, ErrorKind, SnackbarType } from '@shared/definitions';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { switchMap } from 'rxjs';

@Component({
  selector: 'bwc-confirm-delete-account',
  templateUrl: './confirm-delete-account.component.html',
  styleUrls: ['./confirm-delete-account.component.scss'],
})
export class ConfirmDeleteAccountComponent {
  @Output() emitClose = new EventEmitter<void>();

  form = new FormGroup({
    password: new FormControl('', [Validators.required, Validators.minLength(6)]),
  });

  hidePwd = true;
  loading = false;

  constructor(
    @Inject(ENV_CONFIG) private envConfig: EnvConfig,
    private meApiService: MeApiService,
    private authService: AuthService,
    private recaptchaV3Service: ReCaptchaV3Service,
    private snackbarService: SnackbarService
  ) {}

  getFormControl(name: string) {
    return this.form.get(name);
  }

  deleteAccount() {
    if (this.form.invalid || this.loading) return;

    this.loading = true;
    const password = this.form.getRawValue().password;

    this.recaptchaV3Service
      .execute('delete_account')
      .pipe(
        switchMap((captchaToken) =>
          this.meApiService.deleteAccount(password, getCaptchaHeaders(captchaToken, this.envConfig.recaptchaSiteKey))
        )
      )
      .subscribe(
        () => {
          this.authService.logout('/login');
        },
        (error) => {
          this.loading = false;
          if (error.error?.error?.type === ErrorKind.CAPTCHA_INVALID) {
            this.snackbarService.openSnackbar(SnackbarType.Error, {
              duration: 15000,
              data: { msg: 'alert.custom.seems_you_are_bot', translate: true },
            });
          } else if (error.status === 403) {
            this.form.get('password').setErrors({ incorrect_password: true });
          } else {
            this.snackbarService.openSnackbarWithApiError(error.error?.error);
          }
        }
      );
  }
}
